(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('FeedbackSearch', FeedbackSearch);

  FeedbackSearch.$inject = ['$resource', 'API_URI'];

  function FeedbackSearch($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_search/feedbacks/:id';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
